type InfoHandler = (name: string, data?: any, extraData?: any) => void

export const infoHandlers: InfoHandler[] = []

export const addOnInfoHandler = (handler: InfoHandler) => {
  infoHandlers.push(handler)
}
